export default __webpack_public_path__ + "static/media/entity-coref-create-entity.e6b6124e.gif";